export default "__VITE_ASSET__C661ozaw__"